import { MobileAdPlatform } from '@entities/advertising-platform'
import { useChannels } from '@entities/channel'
import { InternetRecourceType } from '@entities/channel/model/types'
import type { Partner } from '@entities/partner'
import type { FormProps } from 'antd'
import { Button, Card, Col, Form, Input, Row, theme, Typography } from 'antd'

const { Text } = Typography

interface AdvertisingPlatformsProps {
    partner: Partner
    isLinkedPartner: boolean
}

export type FieldType = {
    id: number
    type: InternetRecourceType
    name: string
    partnerId: number
}

export const AdvertisingPlatformsMobile = ({ partner, isLinkedPartner }: AdvertisingPlatformsProps) => {
    const {
        partnerResources,
        actions: { createChannel, editChannel, deleteChannel, refetchPartnerResources }
    } = useChannels(partner.id)

    const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
        if (values.id) {
            await editChannel({ id: values.id, data: { name: values.name, type: values.type } })
            refetchPartnerResources()
        } else {
            await createChannel(values)
            refetchPartnerResources()
        }
        form.resetFields()
    }

    const [form] = Form.useForm<FieldType>()

    const {
        token: { colorWhite }
    } = theme.useToken()

    return (
        <>
            <Form
                form={form}
                name="add-adv-platform"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                onFinish={onFinish}
                initialValues={{
                    type: InternetRecourceType.site
                }}
            >
                <Card size="small" style={{ backgroundColor: colorWhite }}>
                    <Row gutter={16} align={'bottom'}>
                        <Form.Item hidden name="partnerId" initialValue={partner.id} />
                        <Form.Item hidden name="isFake" initialValue={true} />
                        <Form.Item hidden name="id" />
                        <Form.Item hidden name="type" />
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Text style={{ fontSize: '17px', color: '#8F8E94' }}>Введите канал или ресурс</Text>
                                }
                                name="name"
                                required={false}
                                rules={[{ required: true, message: 'Обязательное поле' }]}
                            >
                                <Input placeholder="@username / https://telegaplan.me" size="large" />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <div
                                style={{
                                    position: 'fixed',
                                    bottom: 0,
                                    left: 0,
                                    padding: '8px 16px 42px 16px',
                                    zIndex: 10000,
                                    width: '100%',
                                    backgroundColor: colorWhite,
                                    borderTop: '0.5px solid #D3D3D5'
                                }}
                            >
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={isLinkedPartner}
                                    size="large"
                                    style={{ width: '100%' }}
                                >
                                    Сохранить
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Form>
            <Row style={{ marginTop: '10px' }}>
                <Col span={24}>
                    {partnerResources?.length ? (
                        <Row justify={'end'} gutter={[0, 5]}>
                            {partnerResources.map((r) => (
                                <Col span={24} key={r.id}>
                                    <MobileAdPlatform
                                        adPlatform={r}
                                        onDelete={async () => {
                                            await deleteChannel({ id: r.id })
                                            refetchPartnerResources()
                                        }}
                                        onEdit={() => form.setFieldsValue({ ...r, partnerId: partner.id })}
                                    />
                                </Col>
                            ))}
                        </Row>
                    ) : null}
                </Col>
            </Row>
        </>
    )
}
